import { DEFAULT_CURRENCY_SYMBOL } from '@/constants/documents';

export function centsToEuroDisplay(cents: number | undefined) {
  if (!cents) return cents;

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'EUR'
  }).format(cents / 100);
}

export function formatUSD(value: number): string {
  const hasCents = value % 1 !== 0;

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: hasCents ? 2 : 0,
    maximumFractionDigits: hasCents ? 2 : 0
  }).format(value);
}

export function formatEuro(value: number): string {
  const hasCents = value % 1 !== 0;

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: hasCents ? 2 : 0,
    maximumFractionDigits: hasCents ? 2 : 0
  }).format(value);
}

export function formatCryptoAmount(value: number | string | undefined, maxDecimals = 8): string {
  const num = typeof value === 'string' ? Number(value) : value;
  if (num === undefined || num === null || Number.isNaN(num)) return '0';

  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: maxDecimals,
    useGrouping: false
  }).format(num);
}

export function simpleCurrencyFormatter(value: number): string {
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(value);
}

export function centsToEuroDisplaSymbolAfter(cents: number | undefined) {
  if (cents === undefined || cents === null) return cents;

  const formattedNumber = new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(cents / 100);

  return `${formattedNumber}${DEFAULT_CURRENCY_SYMBOL}`;
}

export function formatEuroSymbolAfter(value: number): string {
  const hasCents = value % 1 !== 0;

  const formattedNumber = new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: hasCents ? 2 : 0,
    maximumFractionDigits: hasCents ? 2 : 0
  }).format(value);

  return `${formattedNumber}${DEFAULT_CURRENCY_SYMBOL}`;
}
